(function () {

    'use strict';
    angular.module('app')
        .controller('loginController', ['$scope', '$location', '$routeParams', '$timeout', '$rootScope', 'loginService', 'stateService', 'accountsService', loginController]
            );

    function loginController($scope, $location, $routeParams, $timeout, $rootScope, loginService, stateService, accountsService) {
        //$scope.model = stateService.model;
        
        $rootScope.showLogo = true;
        $scope.model = {};
        $scope.model.clientToken = $routeParams.ct;
        $scope.model.isGoogleAuthenticatorEnabled = false;
        $scope.model.showLostAuthenticator = false;
        $scope.model.clientId = $routeParams.clientId;
        $scope.model.redirectUrl = $routeParams.redirectUrl;
        $scope.model.scope = $routeParams.scope;
        
        $scope.model.showEmailWarning = false;

        if ($location.search().firstRun) {
            $scope.model.showEmailWarning = true;
        }
        $scope.submit = function () {
            
            $scope.model.submitted = true;
            if (!$scope.loginForm.$valid) {
                return;
            }

            $scope.model.working = true;

            loginService.login($scope.model.clientToken, $scope.model.email, $scope.model.password, $scope.model.googleAuthenticatorCode, $scope.model.SecretQuestionAnswer, $scope.model.AuthenticatorRememberMe, $scope.model.clientId, $scope.model.redirectUrl, $scope.model.scope)
                .then(function (response) {
                    
                    if (response.googleAuthenticator) {
                        $scope.model.SecretQuestion = response.secretQuestion;
                        $scope.model.isGoogleAuthenticatorEnabled = true;
                        $scope.model.setGaFocus = true;
                        $scope.model.working = false;
                    } else if (response.googleAuthenticatorNotSetup) {
                        
                        $scope.getGoogleAuthenticatorBarcode(response.encryptedAccountId);
                        $scope.model.googleAuthenticatorNotSetup = response.googleAuthenticatorNotSetup;
                        $scope.model.accountId = response.encryptedAccountId;
                    } else if (response.googleAuthenticatorReset) {
                        $scope.model.googleAuthenticatorReset = true;
                        $scope.model.invalidCredentials = false;
                    } else {
                        if (response.redirect) {
                            location.href = response.redirectUrl;
                        } else {
                            $location.url('/home');
                        }
                    }

            }, function (response) {

                    $scope.model.working = false;

                    if (response.errors.length > 0) {
                        if (response.errors[0].title)
                            $scope.model.errorTitle = response.errors[0].title;
                        else
                            $scope.model.errorTitle = "Login Failed";

                        $scope.model.error = response.errors[0].message;
                    } else {
                        $scope.model.error = null;
                        $scope.model.errorTitle = "Login Failed";
                    }

                    $scope.model.invalidCredentials = true;
                });
        };
        $scope.getSecurityQuestions = function () {
            accountsService.getSecurityQuestions(false)
                .then(function (response) {

                    $scope.model.SecurityQuestions = response;
                    if (!$scope.model.SecurityQuestionId || $scope.model.SecurityQuestionId === 0)
                        $scope.model.SecurityQuestionId = $scope.model.SecurityQuestions[0].id;
                });
        };
        $scope.getGoogleAuthenticatorBarcode = function (accountId) {
            // Load Security Questions also
            $scope.getSecurityQuestions();

            accountsService.getGoogleAuthenticatorBarcode(encodeURIComponent(accountId))
                .then(function (response) {
                    $scope.model.googleAuthenticatorBarcodeUrl = response.barcodeUrl;
                    $scope.model.googleAuthenticatorSecretKey = response.secretKey;
                });
        };

        $scope.lostAuthenticator = function () {
            // Show the lost Secret Question screen and hide the authenticator screen
            $scope.model.showLostAuthenticator = true;
            $scope.model.isGoogleAuthenticatorEnabled = false;

        };

        $scope.verifyGoogleAuthenticator = function () {
            accountsService.verifyGoogleAuthenticator($scope.model.googleAuthenticatorCode, $scope.model.googleAuthenticatorSecretKey, $scope.model.SecurityQuestionId, $scope.model.SecurityQuestionAnswer, $scope.model.accountId)
                .then(function (response) {
                    if (response.isValid) {
                        $scope.submit();
                    } else {
                        $scope.model
                            .googleAuthenticatorVerificationError =
                            'Unfortunately the code you entered is not valid. Please try again.';
                    }
                });
        }

        $scope.forgottenPassword = function () {
            if ($scope.model.clientToken != undefined) {
                $location.url('/account/password/request?ct=' +
                    window.encodeURIComponent($scope.model.clientToken));
            } else {
                $location.url('/account/password/request');
            }
        };

        $scope.createAccount = function () {
            if ($scope.model.clientToken != undefined) {
                $location.url('/account?ct=' + window.encodeURIComponent($scope.model.clientToken));
            } else {
                $location.url('/account');
            }
        };

        $scope.logOut = function () {
            loginService.logOut();

        };
    }
})();